import { connect, Dispatch } from 'react-redux';
import { AppState } from '../../../..';
import { ModalProps, ModalComponent } from '@common/components/modal/_components/modal.component';
import { toggleModal } from '@common/components/common.actions';

// This is used to translate the state of the page to the props on the component
function mapStateToProps(state: AppState, ownProps: { isSmall?: boolean; clickClose?: Function }): Partial<ModalProps> {
  return {
    isSmall: ownProps.isSmall,
    clickClose: ownProps.clickClose
  };
}

// This should create proxy wrappers for actions used by the component
function mapDispatchToProps(dispatch: Dispatch<AppState>): Partial<ModalProps> {
  return {
    closeModal: () => {
      dispatch(toggleModal());
    }
  };
}

// Connect function "wires" both of the map functions and returns a wrapper container for the component
export const Modal = connect(
  mapStateToProps,
  mapDispatchToProps
)(ModalComponent);



// WEBPACK FOOTER //
// ./src/common/components/modal/_components/modal.container.ts